import { IPreloadedState } from 'shared/types/redux';

export const selectRoomsCount = (state: IPreloadedState) => state.marketTrends.filters.roomsCount;
